<div class="container mx-auto px-4 py-8" [dir]="isRTL ? 'rtl' : 'ltr'" *ngIf="!isLoading">
  <div class="mb-10">
    <h3 class="mb-6 text-4xl font-semibold text-[#0A376E] font-rubik">{{ t.interviewDetails }}</h3>
    <h2 class="text-3xl font-bold text-[#0A376E] font-rubik mb-6">{{ t.welcomeHeading }}</h2>

    <div class="grid grid-cols-2 gap-4 mb-6">
      <div class="info-section">
        <h6 class="text-sm font-medium text-[#444444] mb-1 font-rubik">{{ t.candidateIdentifier }}</h6>
        <p class="text-base font-semibold text-[#0D121C] font-rubik">{{ candidateInfo.identifier }}</p>
        <p class="text-xs text-[#919191] mt-1">{{ t.candidateEmail }}: {{ candidateInfo.email }}</p>

      </div>
      <div class="info-section">
        <h6 class="text-sm font-medium text-[#444444] mb-1 font-rubik">{{ t.position }}</h6>
        <p class="text-xs text-[#919191] mt-1">{{ t.interviewDate }}: {{ candidateInfo.interviewDate }}</p>
        <!-- <p class="text-base font-semibold text-[#0D121C] font-rubik">{{ candidateInfo.position }}</p> -->
        <p class="text-xs text-[#919191] mt-1">{{ t.sessionStatus }}: {{ candidateInfo.sessionStatus }}</p>
        <p class="text-xs text-[#919191] mt-1">{{ t.evaluationStatus }}: {{ candidateInfo.evaluationStatus }}</p>
      </div>
    </div>

    <!-- Current application decision status tag -->
    <div class="mt-2" *ngIf="applicationDetails.status">
      <span class="text-xs text-[#919191] me-2 font-rubik">{{ t.currentStatus }}:</span>
      <span [ngClass]="getStatusBadgeClass()">{{ getStatusLabel() }}</span>
    </div>
  </div>

  <div class="mb-10">
    <h6 class="text-2xl font-medium text-[#0D121C] mb-4 font-rubik">{{ t.executiveSummary }}</h6>
    <div class="grid grid-cols-2 gap-2 sm:gap-3 md:gap-4">
      <div class="executive-summary-card">
        <small class="text-[11px] sm:text-[13px] text-[#0D121C] font-medium">{{ t.overallScore }}</small>
        <div class="value text-base sm:text-xl">{{ executiveSummary.overallScore }}/100</div>
      </div>
      <div class="executive-summary-card">
        <small class="text-[11px] sm:text-[13px] text-[#0D121C] font-medium">{{ t.recommendation }}</small>
        <div class="value text-base sm:text-xl ai-recommendation">{{ executiveSummary.recommendation }}</div>
      </div>
    </div>
  </div>

  <div class="mb-10">
    <h6 class="text-2xl font-medium text-[#0D121C] mb-4 font-rubik">{{ t.performanceBreakdown }}</h6>
    <div class="performance-table">
      <div class="performance-row" *ngFor="let item of performanceBreakdown; let last = last" [class.border-b-0]="last">
        <div class="flex items-center gap-4 flex-1">
          <div class="w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0"
            [style.background-color]="'#CFE4FC'">
            <span class="text-[#0A376E] font-bold">%</span>
          </div>
          <div class="flex-1 min-w-0" [class.text-right]="isRTL">
            <h6 class="text-[15px] font-medium text-[#444444] mb-1">{{ getPerformanceTitle(item) }}</h6>
            <p class="text-xs text-[#919191] break-words">{{ item.description || t.noData }}</p>
          </div>
        </div>
        <div class="score-wrapper">
          <svg class="progress-ring" width="52" height="52">
            <circle class="progress-ring-bg" stroke="#e5e7eb" stroke-width="4" fill="transparent" r="22" cx="26"
              cy="26" />
            <circle class="progress-ring-circle" [attr.stroke]="getMatchScoreColor(item.score)" stroke-width="4"
              fill="transparent" r="22" cx="26" cy="26" [style.stroke-dasharray]="getCircumference()"
              [style.stroke-dashoffset]="getStrokeDashoffset(item.score)" />
          </svg>
          <div class="score-text" [style.color]="getMatchScoreColor(item.score)">{{ item.score }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="mb-10" *ngIf="questions.length > 0">
    <h6 class="text-2xl font-medium text-[#0D121C] mb-4 font-rubik">{{ t.questionReview }}</h6>
    <div class="performance-table">
      <div *ngFor="let question of questions; let i = index; let last = last" class="performance-row"
        [class.border-b-0]="last">
        <div class="w-full" [class.text-right]="isRTL">
          <p class="text-sm text-[#0D121C] font-semibold mb-2">
            <strong>{{ t.question }} {{ i + 1 }}:</strong> {{ question.text }}
          </p>
          <p class="text-sm text-[#4F6696] mb-2">{{ question.answer }}</p>
          <p class="text-xs font-semibold" [style.color]="getMatchScoreColor(question.score)">
            {{ t.aiMatchScore }}: {{ question.score }}%
          </p>
        </div>
      </div>
    </div>
  </div>


  <div class="mb-10">
    <h6 class="text-2xl font-medium text-[#0D121C] mb-4 font-rubik">{{ t.aiInsights }}</h6>
    <div class="performance-table">
      <div class="performance-row">
        <div class="w-full" [class.text-right]="isRTL">
          <p class="text-sm text-[#4F6696]">
            <strong class="text-[#0D121C]">{{ t.keyStrengths }}:</strong>
            {{ aiInsights.keyStrengths }}
          </p>
        </div>
      </div>
      <div class="performance-row">
        <div class="w-full" [class.text-right]="isRTL">
          <p class="text-sm text-[#4F6696]">
            <strong class="text-[#0D121C]">{{ t.keyConcerns }}:</strong>
            {{ aiInsights.keyConcerns }}
          </p>
        </div>
      </div>
      <div class="performance-row border-b-0">
        <div class="w-full" [class.text-right]="isRTL">
          <p class="text-sm text-[#4F6696]">
            <strong class="text-[#0D121C]">{{ t.overallFitSummary }}:</strong>
            {{ aiInsights.overallAssessment }}
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="mb-10">
    <h6 class="text-2xl font-medium text-[#0D121C] mb-4 font-rubik">{{ t.interviewVideos }}</h6>
    <div class="video-section">
      <div class="text-center mb-6">
        <div class="inline-flex items-center justify-center">
          <img src="assets/img/floating-robot 1.png" alt="Robot" class="w-20 h-20 object-contain robot-img">
        </div>
        <button class="download-button mt-4 block mx-auto" (click)="downloadPDF()" *ngIf="pdfUrl">
          {{ t.downloadReport }}
        </button>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" *ngIf="questions && questions.length > 0">
        <ng-container *ngFor="let question of questions; let i = index">

          <!-- <div class="video-card" *ngIf="question.questionVideoUrl">
            <div class="video-header">
              <h6 class="video-title">Q{{ i + 1 }} — {{ t.questionAudio }}</h6>
            </div>
            <div class="video-content">
              <ng-container [ngTemplateOutlet]="videoBlock"
                [ngTemplateOutletContext]="{ videoUrl: question.questionVideoUrl, key: 'question_' + i }">
              </ng-container>
            </div>
          </div> -->

          <div class="video-card" *ngIf="question.videoUrl">
            <div class="video-header">
              <h6 class="video-title">Q{{ i + 1 }} — {{ t.candidateAnswer }}</h6>
            </div>
            <div class="video-content">
              <ng-container [ngTemplateOutlet]="videoBlock"
                [ngTemplateOutletContext]="{ videoUrl: question.videoUrl, key: 'main_' + i }">
              </ng-container>
            </div>
          </div>
          <!-- 
          <div class="video-card" *ngIf="question.explainVideoUrl">
            <div class="video-header">
              <h6 class="video-title">Q{{ i + 1 }} — {{ t.explanationAudio }}</h6>
            </div>
            <div class="video-content">
              <ng-container [ngTemplateOutlet]="videoBlock"
                [ngTemplateOutletContext]="{ videoUrl: question.explainVideoUrl, key: 'explain_' + i }">
              </ng-container>
            </div>
          </div> -->

          <div class="video-card" *ngIf="question.additionalVideoUrl">
            <div class="video-header">
              <h6 class="video-title">Q{{ i + 1 }} — {{ t.additional }}</h6>
            </div>
            <div class="video-content">
              <ng-container [ngTemplateOutlet]="videoBlock"
                [ngTemplateOutletContext]="{ videoUrl: question.additionalVideoUrl, key: 'additional_' + i }">
              </ng-container>
            </div>
          </div>

        </ng-container>
      </div>

      <div *ngIf="!questions || questions.length === 0" class="text-center py-12">
        <p class="text-gray-500">{{ t.noVideos }}</p>
      </div>
    </div>
  </div>

  <div class="mb-6">
    <h6 class="text-2xl font-medium text-[#0D121C] mb-4 font-rubik">{{ t.internalNotes }}</h6>
    <textarea class="w-full border border-[#e1e3ea] rounded-lg p-3 text-sm text-[#0D121C]" rows="4"
      [dir]="isRTL ? 'rtl' : 'ltr'" [placeholder]="t.notesPlaceholder" [(ngModel)]="notes" [disabled]="isUpdatingStatus"
      name="internalNotes">
    </textarea>
  </div>

  <p class="text-sm text-green-600 mb-2" *ngIf="statusSuccess">{{ statusSuccess }}</p>
  <p class="text-sm text-red-600 mb-2" *ngIf="statusError">{{ statusError }}</p>

  <div class="flex justify-end gap-3 mt-6">
    <button class="reject-btn" [disabled]="isUpdatingStatus || isRejected" (click)="onRejectApplication()">
      {{ isUpdatingStatus ? t.updating : (isRejected ? t.rejected : t.rejectCandidate) }}
    </button>
    <button class="shortlist-btn" [disabled]="isUpdatingStatus || isAccepted" (click)="onAccept()">
      {{ isUpdatingStatus ? t.updating : (isAccepted ? t.accepted : t.shortlistCandidate) }}
    </button>
  </div>
</div>

<div *ngIf="isLoading" class="text-center py-12">
  <div class="inline-block w-12 h-12 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"
    role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>

<div *ngIf="!isLoading && !report" class="text-center py-12">
  <p class="text-gray-500">{{ t.noSessionData }}</p>
</div>

<ng-template #videoBlock let-videoUrl="videoUrl" let-key="key">
  <div class="video-thumbnail" *ngIf="!videoUrl">
    <p class="text-sm text-gray-400">{{ t.noRecording }}</p>
  </div>

  <div class="video-thumbnail cursor-pointer"
    *ngIf="videoUrl && !videoStates[key]?.secureUrl && !videoStates[key]?.isLoading && !videoStates[key]?.error"
    (click)="playVideo(videoUrl, key)">
    <div class="play-icon-wrapper mb-4 transition-transform duration-300 hover:scale-110">
      <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
        <circle cx="32" cy="32" r="32" fill="rgba(249, 134, 80, 0.9)" />
        <path d="M26 20L44 32L26 44V20Z" fill="white" />
      </svg>
    </div>
    <p class="text-sm text-[#0D121C] font-medium">{{ t.clickToPlay }}</p>
  </div>

  <div class="video-thumbnail" *ngIf="videoStates[key]?.isLoading">
    <div class="inline-block w-12 h-12 border-4 border-orange-600 border-t-transparent rounded-full animate-spin"></div>
    <p class="text-sm text-[#0D121C] font-medium mt-4">{{ t.loadingVideo }}</p>
  </div>

  <div class="video-player-wrapper flex items-center justify-center bg-black"
    *ngIf="videoStates[key]?.secureUrl && videoStates[key]?.isPlaying && !videoStates[key]?.error">
    <video [src]="videoStates[key].secureUrl" controls autoplay class="video-player" preload="metadata"
      (ended)="onVideoEnded(key)" (error)="onVideoError(key, $event)" (loadedmetadata)="onVideoLoaded(key, $event)">
    </video>
  </div>

  <div class="video-thumbnail cursor-pointer"
    *ngIf="videoStates[key]?.secureUrl && !videoStates[key]?.isPlaying && !videoStates[key]?.isLoading && !videoStates[key]?.error"
    (click)="playVideo(videoUrl, key)">
    <div class="play-icon-wrapper mb-4 transition-transform duration-300 hover:scale-110">
      <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
        <circle cx="32" cy="32" r="32" fill="rgba(249, 134, 80, 0.9)" />
        <path d="M26 20L44 32L26 44V20Z" fill="white" />
      </svg>
    </div>
    <p class="text-sm text-[#0D121C] font-medium">{{ t.clickToReplay }}</p>
  </div>

  <div class="video-thumbnail" *ngIf="videoStates[key]?.error">
    <div class="text-red-600 mb-4">
      <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
        <circle cx="32" cy="32" r="32" fill="rgba(220, 38, 38, 0.1)" />
        <path d="M32 20v16M32 44v.01" stroke="#DC2626" stroke-width="3" stroke-linecap="round" />
      </svg>
    </div>
    <p class="text-sm text-red-600 font-medium mb-3">{{ videoStates[key].error }}</p>
    <button class="px-4 py-2 bg-orange-600 text-white rounded-lg text-sm hover:bg-orange-700 transition-colors"
      (click)="retryVideo(key)">
      {{ t.retry }}
    </button>
  </div>
</ng-template>